// @flow

import ApiObject from '../ApiObject';

export default class BookingNotificationSettings extends ApiObject {

  emails: Array<String> = [];

  phones: Array<String> = [];

  phoneEnabled: boolean = false;

  emailEnabled: boolean = false;

  isDisabled() {
    return !this.phoneEnabled && !this.emailEnabled;
  }
}
